export default {
  init() {
    this.initUsesCasesSlider();
    this.initExperiencesSlider();
    this.handleWpcf7FileUpload();
    this.initMobileMenu();
  },
  
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
  
  initUsesCasesSlider() {
    $('[data-slider-usecases]').slick({
      variableWidth: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
            adaptiveHeight: true,
          },
        },
      ],
    });
  },
  
  initExperiencesSlider() {
    $('[data-slider-experiences]').slick({
      infinite: false,
      slidesToShow: 2,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
  
  handleWpcf7FileUpload() {
    $('.wpcf7-file').on('change', function(e) {
      var $input = $(this);
      var $container = $input.closest('.wpcf7-file-container');
      
      if( !$container.length ) {
        return;
      }
      
      var fileName = '';
      if( $input.files && $input.files.length > 1 ) {
        fileName = ( $input.attr( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
      }
      else {
        fileName = e.target.value.split( '\\' ).pop();
      }
      
      $input.closest('.wpcf7-form-control-wrap').siblings('label').html(fileName);
    });
  },
  
  initMobileMenu() {
    $('[data-toggle-mobile-menu]').on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('is-active');
      $('body').toggleClass('menu-mobile-opened');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js